var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlayStore(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 170,
    height: 64,
    viewBox: "0 0 170 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "play_store",
    "data-name": "play store",
    transform: "translate(-375 -1513)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_68",
    "data-name": "Rectangle 68",
    d: "M20,0H150a20,20,0,0,1,20,20V54a10,10,0,0,1-10,10H10A10,10,0,0,1,0,54V20A20,20,0,0,1,20,0Z",
    transform: "translate(375 1513)"
  }), /*#__PURE__*/React.createElement("text", {
    id: "Download_on_the",
    "data-name": "Download on the",
    transform: "translate(420 1537)",
    fill: "#fff",
    fontSize: 14,
    fontFamily: "Mulish-Regular, Mulish"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Download on the")), /*#__PURE__*/React.createElement("text", {
    id: "Play_Store-2",
    "data-name": "Play Store",
    transform: "translate(420 1562)",
    fill: "#fff",
    fontSize: 24,
    fontFamily: "Mulish-Medium, Mulish",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Play Store")), /*#__PURE__*/React.createElement("g", {
    id: "playstore",
    transform: "translate(359.451 1529)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23",
    "data-name": "Group 23",
    transform: "translate(23.549 0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M68.6,11.263C64.93,9.132,59.038,5.709,49.9.4A2.135,2.135,0,0,0,47.962.135l15.68,16.277Z",
    transform: "translate(-46.398 -0.012)",
    fill: "#32bbff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M25.113,1.93a2.371,2.371,0,0,0-.346.144,2.226,2.226,0,0,0-1.218,1.985V31.551a2.226,2.226,0,0,0,1.218,1.985,2.4,2.4,0,0,0,.346.145L41.39,17.805Z",
    transform: "translate(-23.549 -1.807)",
    fill: "#32bbff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M63.636,255.98l-15.68,16.277a2.113,2.113,0,0,0,1.938-.263c8.863-5.152,14.688-8.534,18.4-10.683l.3-.178Z",
    transform: "translate(-46.392 -240.384)",
    fill: "#32bbff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    "data-name": "Path 62",
    d: "M23.549,255.98v14.094a2.289,2.289,0,0,0,1.218,2.035,2.361,2.361,0,0,0,.346.148L41.39,255.98Z",
    transform: "translate(0 -240.383)",
    fill: "#2c9fd9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    d: "M44.918.386A2.3,2.3,0,0,0,42.561.272L58.937,16.647l5.4-5.4C60.521,9.121,54.405,5.7,44.918.386Z",
    transform: "translate(-17.794 0)",
    fill: "#29cc5e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    d: "M58.937,252.126,42.561,268.5a2.279,2.279,0,0,0,2.357-.115c9.2-5.152,15.248-8.534,19.1-10.683l.316-.178Z",
    transform: "translate(-17.794 -236.776)",
    fill: "#d93f21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    d: "M306.742,178.183a2.283,2.283,0,0,0-1.175-2.006s-1.461-.815-5.938-3.319l-5.326,5.326,5.331,5.331c4.428-2.486,5.933-3.325,5.933-3.325A2.283,2.283,0,0,0,306.742,178.183Z",
    transform: "translate(-254.193 -162.184)",
    fill: "#ffd500"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    "data-name": "Path 66",
    d: "M305.567,257.986a2.283,2.283,0,0,0,1.175-2.006H294.3l5.331,5.331C304.062,258.825,305.567,257.986,305.567,257.986Z",
    transform: "translate(-254.193 -240.059)",
    fill: "#fa0"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayStore);
export default __webpack_public_path__ + "static/media/play_store.31eedea694df13ce8e0ba3d98c63c40d.svg";
export { ForwardRef as ReactComponent };